import { render, staticRenderFns } from "./ExtraInfo.vue?vue&type=template&id=5d4e2e2b"
import script from "./ExtraInfo.vue?vue&type=script&lang=js"
export * from "./ExtraInfo.vue?vue&type=script&lang=js"
import style0 from "./ExtraInfo.vue?vue&type=style&index=0&id=5d4e2e2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports